import * as types from '../actions/types';
import GameInstance from "common/models/game-instance";

const initState = {
    instance: null,
    loading: false,
    loadingError: null,

    sendingInput: false,
    sendingInputError: null,

    discarding: false,
    discardingError: null
};

export default function GameInstanceReducer (state = initState, action) {

    switch (action.type)
    {
        case types.GAME_INSTANCE_LOAD:
            return {...state, loading: true, loadingError: null };

        case types.GAME_INSTANCE_LOAD_SUCCESS:
            return {...state, instance: new GameInstance(action.payload.instance), loading: false, loadingError: null };

        case types.GAME_INSTANCE_LOAD_ERROR:
            return {...state, instance: null, loading: false, loadingError: action.payload };

        case types.GAME_INSTANCE_INPUT:
            return {...state, sendingInput: true, sendingInputError: null };

        case types.GAME_INSTANCE_INPUT_SUCCESS:
            return {...state, instance: new GameInstance(action.payload.instance), sendingInput: false, sendingInputError: null };

        case types.GAME_INSTANCE_INPUT_ERROR:
            return {...state, instance: null, sendingInput: false, sendingInputError: action.payload };

        case types.GAME_INSTANCE_DISCARD:
            return {...state, discarding: true, discardingError: null};

        case types.GAME_INSTANCE_DISCARD_SUCCESS:
            return {...state, discarding: false, discardingError: null};

        case types.GAME_INSTANCE_DISCARD_ERROR:
            return {...state, discarding: false, discardingError: action.payload};

        default:
            return state;
    }

}

